import React, { useState, useReducer, useEffect } from "react";

import "./MittiDetails.css";
import axios from "axios";
import { config } from "../../../confi";
import Spinner from "../../Loader/Spinner";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';


import Mytable from "./Mytable/Mytable";
import { background } from "@chakra-ui/react";

function formatDate(date) {
  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function MittiDetails() {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);
  const [member_reciet_no, Setmember_reciet_no] = useState("");
  const [member_data, setmember_data] = useState([]);

  // ----------------drop search list --------------------------//

  const [list, setList] = useState(false);
  const [searchinput, setsearchinput] = useState("");
  const [DataSearch, setDataSearch] = useState([]);

  const handleSelect = (selectedItem) => {
    setmember_data(selectedItem);
    setShow(true);
    setList(false);
    setsearchinput(selectedItem);
  };

  // -----------------------------//

  const handleInputChange = (e) => {
    if (e.target.value.length === 0) {
      setList(false);
    }
    Setmember_reciet_no(e.target.value);
  };

  const FetchHandler = async (e) => {
    e.preventDefault();
    setDataSearch([]);
    if (member_reciet_no.length === 0) {
      return;
    }
    setList(true);

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_fe_me",
      payload: { member_reciet_no: member_reciet_no },
    });

    try {
      setLoading(true);
      setShow(false);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // console.log(response.data.data[0].result);

      if (response.status === 200 && response.data.status === "0") {
        if (response.data.data[0].result.length > 0) {
          // setmember_data(response.data.data);
          setDataSearch(response.data.data[0].result);
          //  setList(true)
          // setShow(true);
        } else {
          setmsg("Invalid member id");
        }
      } else {
      }
    } catch (error) {}

    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <p>
          <Spinner />
        </p>
      ) : (
        <div>
          {msg ? (
            <p className="msg" style={{ color: "red" }}>
              {msg}
            </p>
          ) : (
            <div className="MittiDetails">
              <div className="button-MittiDetails">
                <button>New Mitti</button>
              </div>
              <div className="book">
                <p style={{ color: "blue" }}>Book a Mitti</p>
              </div>
              <div className="Fetch-Receipt">
                <div>
                  <label className="MittiDetails-label" htmlFor="Receipt-No">
                    Membership Receipt No
                  </label>
                  <br></br>
                  <div className="need-Fetch-Receipt">
                    {/* <input
                      className="MittiDetails-input"
                      id="Receipt-No"
                      type="text"
                      value={member_reciet_no}
                      onChange={handleInputChange}
                    /> */}

                    <div className="list-input">
                      <input
                        value={member_reciet_no}
                        onChange={handleInputChange}
                      ></input>

                      {list && (
                        <div className="div-list">
                          <ul className="g-number">
                            {DataSearch.length > 0 ? (
                              DataSearch.map((obj) => {
                                return (
                                  <li
                                    className="number"
                                    onClick={() => handleSelect(obj)}
                                  >
                                    {obj.name_person} f/h {obj.father_hus_name}{" "}
                                    {obj.membership_rec_no}
                                  </li>
                                );
                              })
                            ) : (
                              <li style={{ textAlign: "center" }}>
                                No Record found
                              </li>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>

                    <button className="fetch-button" onClick={FetchHandler}>
                      Fetch
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {show && <Fetch Data={member_data} />}
    </>
  );
}

//  -------------- second component -------------///////////

function Fetch(prop) {
  let {
    row_id,
    name_person,

    mobile_no,
    father_hus_name,
    all_miti,

    membership_rec_no,
    membership_year,
  } = prop.Data;

  // console.log(prop.Data);

  ///---- state for  regular--- ///
  const [regular, setregular] = useState(0);
  let [r_day, setr_day] = useState(1);
  let [r_amount, setr_amount] = useState(0);
  let [r_price, setr_price] = useState(0);

  ////----state for specail ---///
  const [Special, setSpecial] = useState(0);
  let [s_day, sets_day] = useState(1);
  let [s_price, sets_price] = useState(0);
  let [s_amount, sets_amount] = useState(0);

  ///////------state for olian -----///////
  const [Olian, setOlian] = useState(0);
  let [O_day, setO_day] = useState(1);
  let [O_price, setO_price] = useState(0);
  let [O_amount, setO_amount] = useState(0);

  ///// ---------state for sponsor ------/////////
  const [sponsor, setsponsor] = useState(0);
  let [spon_day, setspon_day] = useState(1);
  let [spon_price, setspon_price] = useState(0);
  let [spon_amount, setspon_amount] = useState(0);

//------------------    state for other  ------------//
  const [other_miti,Setother_miti] = useState(0)
  let [other_amount,Setother_amount] = useState(0)

  ///----------- other state -----///
  // const [paidby,setPaidby] = useState("")
  const [recieve, setrecieve] = useState(0);
  const [commited_amount,setCommited_amount] = useState(0)
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);
  const [checkcommit,setCheckcommit] =useState(false)
  const [cash,setCash]  = useState('');
  const [cheque_no,setCheque_no] = useState('')
  const [cheque_amount,setCheque_amount] = useState('')
  const [date_receive,Setdate_receive] = useState('')

  const handle_input = (e) => {
    if (e.target.name === "regu_price") {
      setr_price(e.target.value);
    }


    if (e.target.name === "regu_day") {
      setr_day(e.target.value);
    }


    if (e.target.name === "regu_amount") {
      setr_day(1);
      setr_amount(e.target.value);
    }


    if (e.target.name === "regular") {
      setregular(regular === 0 ? 1 : 0);
      setr_price(regular ? 0 : 21000);
    }


    /////--------------------special--------------//
    if (e.target.name === "special") {
      setSpecial(Special === 0 ? 2 : 0);
      sets_price(Special ? 0 : 51000);
    }

    if (e.target.name === "spe_day") {
      sets_day(e.target.value);
    }
    if (e.target.name === "spe_amount") {
      sets_amount(e.target.value);
    }

    if (e.target.name === "spe_price") {
      sets_price(e.target.value);
    }

    ///---------------------Olian-----------------------------////

    if (e.target.name === "Olian") {
      setOlian(Olian === 0 ? 3 : 0);
      setO_price(Olian ? 0 : 0);
    }
    if (e.target.name === "O_day") {
      setO_day(e.target.value);
    }

    if (e.target.name === "O_price") {
      setO_price(e.target.value);
    }
    if (e.target.name === "O_amount") {
      setO_amount(e.target.value);
    }

    ///---------------------sponsor---------------------///
    if (e.target.name === "spon") {
      setsponsor(sponsor === 0 ? 4 : 0);
      setspon_price(sponsor ? 0 : 0);
    }

    if (e.target.name === "spon_day") {
      setspon_day(e.target.value);
    }

    if (e.target.name === "spon_price") {
      setspon_price(e.target.value);
    }

    if (e.target.name === "spon_amount") {
      setspon_amount(e.target.value);
    }

    //-----------other mitt -----------//
    if(e.target.name ==="other_miti"){
      Setother_miti(other_miti === 0?5:0)
    }

    if(e.target.name ==="other_amount"){

      Setother_amount(e.target.value)
    }


    //----------------------------------------------------------------------------------//
    if (e.target.name === "receive"){
      setrecieve(e.target.value);
    }

// if(e.target.name === "paidby")
// {

// setPaidby(e.target.value)
// }

if(e.target.name ==="commited"){
 
if(e.target.value >=  r_day * r_price +
  s_day * s_price +
  O_day * O_price +
  spon_day * spon_price+Number(other_amount)){

    setCheckcommit(false)
  }

else{
  setCheckcommit(true)
}

    setCommited_amount(e.target.value)
 
}


if(e.target.name ==='cash'){
  setCash(e.target.value)

  setrecieve(+e.target.value + (+cheque_amount))
}


if(e.target.name ==='ch_no'){

  setCheque_no(e.target.value)
}

if(e.target.name ==='ch_amount'){

  setCheque_amount(e.target.value)
  setrecieve(+e.target.value + (+cash))
}


if(e.target.name ==='date_r'){

Setdate_receive(e.target.value)

}



  };
console.log(date_receive)
  //////////////--------------------------////////////

  const submitHandler = async (e) => {
    e.preventDefault();
    let miti = {};

    let Regular;
    let special;
    let olian;
    let Sponsor;
    let others
    let cash_amount;
    let cheq_no;
    let cheque_amounts;
    let recie_am = {}

    if (regular === 1) {
      Regular = {
        type: regular,
        days: r_day,
        price: r_price,
        amount: r_day * r_price,
      };
      miti.regular = Regular;
    }

    if (Special === 2) {
      special = {
        type: Special,
        days: s_day,
        price: s_price,
        amount: s_day * s_price,
      };

      miti.Special = special;
    }

    if (Olian === 3) {
      olian = {
        type: Olian,
        days: O_day,
        price: O_price,
        amount: O_day * O_price,
      };
      miti.Olian = olian;
    }

    if (sponsor === 4) {
      Sponsor = {
        type: sponsor,
        days: spon_day,
        price: spon_price,
        amount: spon_day * spon_price,
      };

      miti.sponsor = Sponsor;
    }


  if(other_miti === 5){
    
    others = {
      type:other_miti,
      amount:other_amount

    }
miti.Other = others


  }


    // console.log(miti);

    let total =
      r_day * r_price +
      s_day * s_price +
      O_day * O_price +
      spon_day * spon_price +Number(other_amount);

    let recieved = +recieve;




    let Balanced = commited_amount? commited_amount-recieved : total - recieved;
    let today =  new Date();
    let formattedDate =    date_receive ||formatDate(today);

    // console.log(total);

    if (total === 0) {
      return;
    }
 
    if (!commited_amount || commited_amount < total){
    
        setCheckcommit(true)
      return 
    }
      
//--------------------------------///

   if(cash) {

      recie_am.cash=cash
   }
   

   if(cheque_amount){
recie_am.cheque_amount = cheque_amount
   
   }
      

   if(cheque_no){
   recie_am.cheq_no = cheque_no

   }

   if(recieve)
{    
  recie_am.date =formattedDate
  recie_am.amount = +recieve

}

// { date: formattedDate, amount: +recieve,cash:cash_amount,cheque_no:cheq_no,cheque_amount:cheque_amounts }

    let formdata = {
      membership_id: row_id,
      miti: miti,
      recieve_amount: recieved
        ? [recie_am]
        : [],
      total: total,
      balance: Balanced,
      commited_amount:commited_amount || total

    };

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_miti_cr",
      payload: formdata,
    });

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(response);

      // console.log(response.data);
      if (response.status === 200 && response.data.status === "0") {

        Swal.fire({
          icon: 'success',
          title: 'Registered!',
          text: 'New Miti has been Registered successfully.',
          timer: 2000, // The alert will automatically close after 2 seconds
        });
        setmsg("Miti Registration Success");
      } else {
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {loading ? (
        <p className="loading">
          <Spinner />
        </p>
      ) : (
        <div>
          {msg ? (
            <p className="msg">{msg}</p>
          ) : (
            <div style={{ height: "70%" }}>
              <div className="Show-info">
                <span>
                  {" "}
                  <b> Member Name:</b>&nbsp; {name_person}
                </span>
                <span>
                  {" "}
                  <b>F/H Name:</b>&nbsp; {father_hus_name}
                </span>
                <span>
                  <b>Membership Year:</b>&nbsp; {membership_year}
                </span>
                <span>
                  <b>Mobile No:</b>&nbsp;{mobile_no}
                </span>
                <span>
                  <b>Membership No:</b>&nbsp;{membership_rec_no}
                </span>
              </div>
              <Mytable miti={all_miti} />
              <div>
                <div className="Select-Mitti">Select Mitti</div>
                <div>
                  <div className="mitti-days-amount">
                    <div className="chekbox-set-width">
                      <input
                        // style={{ width: "auto" }}
                        className="bb34"
                        type="checkbox"
                        name="regular"
                        onChange={(e) => handle_input(e)}
                        value={regular}
                        checked={regular === 1}
                      ></input>
                      <label style={{ marginRight: "3em" }}>Regular</label>
                    </div>
                    <div>
                      <label>Mitti &nbsp;</label>
                      <input
                        className="Show-info-input-day"
                        // style={{ width: "2em", marginRight: "3em" }}
                        type="text"
                        name="regu_day"
                        value={r_day}
                        onChange={(e) => handle_input(e)}
                      ></input>
                    </div>
                    <div className="price-flex">
                      <div>
                        <label>Price</label>
                        <input
                          className="price"
                          type="number"
                          name="regu_price"
                          value={r_price}
                          onChange={(e) => handle_input(e)}
                        ></input>
                      </div>
                      <div>
                        <label>Amount</label>
                        <input
                          className="price"
                          type="number"
                          name="regu_amount"
                          disabled={true}
                          value={r_price * r_day}
                          onChange={(e) => handle_input(e)}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div className="mitti-days-amount">
                    <div className="chekbox-set-width">
                      <input
                        // style={{ width: "auto" }}
                        className="bb34"
                        type="checkbox"
                        name="special"
                        value={Special}
                        checked={Special === 2}
                        onChange={(e) => handle_input(e)}
                      ></input>
                      <label style={{ marginRight: "3em" }}>Special</label>
                    </div>
                    <div>
                      <label>Mitti &nbsp;</label>
                      <input
                        className="Show-info-input-day"
                        style={{ width: "2em", marginRight: "3em" }}
                        type="text"
                        name="spe_day"
                        value={s_day}
                        onChange={(e) => handle_input(e)}
                      ></input>
                    </div>
                    <div className="price-flex">
                      <div>
                        <label>Price</label>
                        <input
                          className="price"
                          type="number"
                          name="spe_price"
                          value={s_price}
                          onChange={(e) => handle_input(e)}
                        ></input>
                      </div>
                      <div>
                        <label>Amount</label>
                        <input
                          className="price"
                          type="number"
                          name="spe_amount"
                          disabled={true}
                          value={s_day * s_price}
                          onChange={(e) => handle_input(e)}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div className="mitti-days-amount">
                    <div className="chekbox-set-width">
                      <input
                        // style={{ width: "auto" }}
                        className="bb34"
                        type="checkbox"
                        name="Olian"
                        value={Olian}
                        onChange={(e) => handle_input(e)}
                      />
                      <label style={{ marginRight: "3em" }}>Olian</label>
                    </div>
                    <div>
                      <label>Mitti &nbsp;</label>
                      <input
                        className="Show-info-input-day"
                        style={{ width: "2em", marginRight: "3em" }}
                        type="text"
                        name="O_day"
                        value={O_day}
                        checked={Olian === 3}
                        onChange={(e) => handle_input(e)}
                      />
                    </div>
                    <div className="price-flex">
                      <div>
                        <label>Price</label>
                        <input
                          className="price"
                          type="number"
                          name="O_price"
                          value={O_price}
                          onChange={(e) => handle_input(e)}
                        />
                      </div>
                      <div>
                        <label>Amount</label>
                        <input
                          className="price"
                          type="number"
                          name="O_amount"
                          disabled={true}
                          value={O_day * O_price}
                          onChange={(e) => handle_input(e)}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div className="mitti-days-amount">
                    <div className="chekbox-set-width">
                      <input
                        // style={{ width: "auto" }}
                        className="bb34"
                        type="checkbox"
                        name="spon"
                        value={sponsor}
                        checked={sponsor === 4}
                        onChange={(e) => handle_input(e)}
                      ></input>
                      <label style={{ marginRight: "3em" }}>Sponsorship </label>
                    </div>
                    <div>
                      <label>Mitti &nbsp;</label>
                      <input
                        className="Show-info-input-day"
                        style={{ width: "2em", marginRight: "3em" }}
                        type="text"
                        name="spon_day"
                        value={spon_day}
                        onChange={(e) => handle_input(e)}
                      ></input>
                    </div>
                    <div className="price-flex">
                      <div>
                        <label>Price</label>
                        <input
                          className="price"
                          type="number"
                          name="spon_price"
                          value={spon_price}
                          onChange={(e) => handle_input(e)}
                        />
                      </div>
                      <div>
                        <label>Amount</label>
                        <input
                          className="price"
                          type="number"
                          name="spon_amount"
                          disabled={true}
                          value={spon_day * spon_price}
                          onChange={(e) => handle_input(e)}
                        />
                      </div>
                    </div>
                  </div>

               <div className="mitti-days-amount">
                    <div className="chekbox-set-width" >
                      <input
                        // style={{ width: "auto" }}
                        className="bb34"
                        type="checkbox"
                        name="other_miti"
                        value={other_miti}
                        checked={other_miti === 5}
                        onChange={(e) => handle_input(e)}
                      ></input>
                      <label style={{ marginRight: "3em" }}>Other </label>
                    </div>
                  
                    <div className="price-flex"style={{marginLeft:"8.5%"}}>
                      <div>
                        <label>Amount</label>
                        <input
                          className="price"
                          type="text"
                          name="other_amount"
                          value={other_amount}
                          onChange={(e) => handle_input(e)}
                        />
                      </div>
                    
                    </div>
                  </div> 

                </div>
              </div>
              <div className="totel-amount-to-submit">

              <div>
                  <b>Total Amount</b> :{" "}
                  {r_day * r_price +
                    s_day * s_price +
                    O_day * O_price +
                    spon_day * spon_price + Number(other_amount)}
                  &nbsp;  /-
                </div>
              <div style={{ display: "flex" }}>
                  <div style={{ marginRight: "1em" }}>
          Commited Amount  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <div>
                    <input
                     
                      type="text"
                      name="commited"
                      value ={commited_amount === 0 ? r_day * r_price +
                        s_day * s_price +
                        O_day * O_price +
                        spon_day * spon_price + Number(other_amount):commited_amount}
                      onChange={(e) => handle_input(e)}
                      />
                    {checkcommit&& <p style={{color:"red"}}>committed amount must not less than total amount</p>}
                  </div>
                </div>
                
{/*               
                <div style={{ display: "flex" }}>
                  <div style={{ marginRight: "1em" }}>
                    Amount Received Today
                  </div>
                  <div>
                    <input
                      type="number"
                      name="receive"
                      value={recieve}
                      onChange={(e) => handle_input(e)}
                    />
                  </div>
                </div> */}

                <div id="amount_div" style={{ display: "flex"
 }}>
                  <div style={{ display: "flex" }}>
                  <div id ='cash_div'>
                    Cash  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <div>
                    <input
                      type="text"
                      name="cash"
                      value={cash}
                      onChange={(e) => handle_input(e)}
                    />
                  </div>

                  </div>




                  <div style={{ display: "flex"}}>
                  <div style={{ marginRight: "0em" }}>
                  &nbsp; Cheque amount  &nbsp;
                  </div>
                  <div>
                    <input
                      type="text"
                      name="ch_amount"
                      value={cheque_amount}
                      onChange={(e) => handle_input(e)}
                    />
                  </div>

                  </div>

                  <div style={{ display: "flex"}}>
                  <div style={{ marginRight: "0em" }}>
                  &nbsp;&nbsp; Cheque.no  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <div>
                    <input
                      type="text"
                      name="ch_no"
                      value={cheque_no}
                      onChange={(e) => handle_input(e)}
                    />
                  </div>

                  </div>

                  
                </div>
                   
                <div style={{ display: "flex" }}>
                  <div id ='cash_div'>
               Date &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <div>
                    <input style={{maxWidth:'15em',minWidth:"12.5em"}}
                      type="date"
                      name="date_r"
                      value={date_receive}
                      onChange={(e) => handle_input(e)}
                    />
                  </div>

                  </div>

                <div style={{ display: "flex" }}>
                  <div style={{ marginRight: "1em" }}>
                    Amount Received Today
                  </div>
                  <div>
                    <input
                      type="number"
                      name="receive"
                      value={recieve}
                      // onChange={(e) => handle_input(e)}
                      readOnly
                    />
                  </div>
                </div>
                <div>
                 <b>Balance</b> :&nbsp; 
                  {commited_amount ? commited_amount - recieve :r_day * r_price +
                    s_day * s_price +
                    O_day * O_price +
                    spon_day * spon_price +Number(other_amount)  -
                    recieve}
                  &nbsp; /-
                </div>
                <div>
                  <button type="submit" onClick={submitHandler}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default MittiDetails;
